import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import Dashboard from '@/views/Dashboard'
import DppEditor from '@/views/DppEditor'
import LandingPage from '@/views/LandingPage'
import LandingPagesList from '@/views/LandingPagesList'
import Navigation from '@/views/Navigation'
import ProductElabel from '@/views/ProductElabel'
import ProductDetails from '@/views/ProductDetails'
import Products from '@/views/Products'
import Upgrade from '@/views/Upgrade'
import Gallery from '@/views/Gallery.vue'
import Profile from '@/views/Profile.vue'

// Profile components
import ProfileMenu from '@/components/profile/ProfileMenu.vue'
import AccountInformation from '@/components/profile/AccountInformation.vue'
import SubscriptionAndBilling from '@/components/profile/SubscriptionAndBilling.vue'
import TeamMembers from '@/components/profile/TeamMembers.vue'

// Product Details Components
import ProductDetailsGs1 from '@/views/ProductDetails/ProductDetailsGs1'
import ProductDetailsQr from '@/views/ProductDetails/ProductDetailsQr'
import ProductDetailsRedirection from '@/views/ProductDetails/ProductDetailsRedirection'
import ProductDetailsInfo from '@/views/ProductDetails/ProductDetailsInfo'
import ProductDetailsNavigation from '@/views/ProductDetails/ProductDetailsNavigation'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'dashboard',
    components: {
      tab: Dashboard,
      navigation: Navigation
    },
    props: { navigation: { active: 'DASHBOARD' } }
  },
  {
    path: '/products',
    name: 'products',
    components: {
      tab: Products,
      navigation: Navigation
    },
    props: { navigation: { active: 'PRODUCTS' } },
    children: [
      {
        name: 'products.new',
        path: 'new',
        components: {
          tab: Products,
          navigation: Navigation
        },
        props: { navigation: { active: 'PRODUCTS' } }
      }
    ]
  },
  {
    name: 'products.details',
    path: '/products/:id/details',
    components: {
      tab: ProductDetails,
      navigation: Navigation
    },
    props: { navigation: { active: 'PRODUCTS' } },
    children: [
      {
        name: 'products.info',
        path: 'product-info',
        components: {
          tab: ProductDetailsInfo,
          navigation: ProductDetailsNavigation
        }
      },
      {
        name: 'products.gs1',
        path: 'gs1',
        components: {
          tab: ProductDetailsGs1,
          navigation: ProductDetailsNavigation
        }
      },
      {
        name: 'products.qr',
        path: 'qr',
        components: {
          tab: ProductDetailsQr,
          navigation: ProductDetailsNavigation
        }
      },
      {
        name: 'products.redirection',
        path: 'redirection',
        components: {
          tab: ProductDetailsRedirection,
          navigation: ProductDetailsNavigation
        }
      }
    ]
  },
  {
    name: 'products.elabel',
    path: '/products/:id/elabel',
    components: {
      tab: ProductElabel,
      navigation: Navigation
    },
    props: { navigation: { active: 'PRODUCTS' } }
  },
  {
    name: 'products.dpp',
    path: '/products/:id/dpp',
    components: {
      tab: DppEditor,
      navigation: Navigation
    },
    props: { navigation: { active: 'PRODUCTS' } }
  },
  {
    path: '/landing-pages',
    name: 'landing-pages',
    components: {
      tab: LandingPagesList,
      navigation: Navigation
    },
    props: { navigation: { active: 'LANDING-PAGE' } }
  },
  {
    path: '/landing-pages/:id',
    name: 'landing-page.edit',
    components: {
      tab: LandingPage,
      navigation: Navigation
    },
    props: { navigation: { active: 'LANDING-PAGE' } }
  },
  {
    path: '/upgrade',
    name: 'upgrade',
    components: {
      tab: Upgrade,
      navigation: Navigation
    },
    props: { navigation: { active: 'UPGRADE' } }
  },
  {
    path: '/gallery',
    name: 'gallery',
    components: {
      tab: Gallery,
      navigation: Navigation
    },
    props: { navigation: { active: 'GALLERY' } }
  },
  {
    path: '/profile',
    components: {
      tab: Profile,
      navigation: Navigation
    },
    children: [
      {
        name: 'profile.info',
        path: 'info',
        components: {
          tab: AccountInformation,
          sidebar: ProfileMenu
        }
      },
      {
        name: 'profile.subscription',
        path: 'subscription',
        components: {
          tab: SubscriptionAndBilling,
          sidebar: ProfileMenu
        }
      },
      {
        name: 'profile.team-members',
        path: 'team-members',
        components: {
          tab: TeamMembers,
          sidebar: ProfileMenu
        }
      },
      {
        path: '',
        redirect: { name: 'profile.info' }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// Global guard: block navigation when there are unsaved changes in product details tabs
router.beforeEach((to, from, next) => {
  const hasUnsaved = store.getters.hasUnsavedChanges
  const fromIsProduct = from.name && from.name.startsWith('products.')
  if (hasUnsaved && fromIsProduct && to.name !== from.name) {
    // Cancel navigation and notify UI to show dialog
    next(false)
    // Emit an event with intended route to resume later
    const event = new CustomEvent('unsaved-nav-attempt', { detail: { to } })
    window.dispatchEvent(event)
  } else {
    next()
  }
})

export default router
